import { render, staticRenderFns } from "./ViewBabyVaccinationChart.vue?vue&type=template&id=2c986505&scoped=true&"
import script from "./ViewBabyVaccinationChart.vue?vue&type=script&lang=js&"
export * from "./ViewBabyVaccinationChart.vue?vue&type=script&lang=js&"
import style0 from "./ViewBabyVaccinationChart.vue?vue&type=style&index=0&id=2c986505&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c986505",
  null
  
)

export default component.exports